import { Attribute } from "../../models/RestModels";

export function getEmptyAttribute(): Attribute
{
		return {
			id:0,
			created: new Date(),
			created_by_user_id: 0,
			name: '',
			updated_by_user_id: 0,
			updated: new Date(),
		};
}
